module.exports = __webpack_public_path__ + "static/img/reyzar-blue.6a90685.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/reyzar-blue.png
// module id = O1q7
// module chunks = 0